import { useNavigate } from 'react-router-dom';
import { SEARCHRESULTS_ERRORTEXT, WATCHEDRESULTS_ERRORTEXT } from '../../../Constants/Constants';
import './NoResults.scss';

export type TNoResultsContainerProps = {
  isWatched?: boolean;
  isMatchedLoadsHome?: boolean;
};

const NoResults = (props: TNoResultsContainerProps) => {
  const { isWatched = false, isMatchedLoadsHome = false } = props;
  const navigate = useNavigate();

  const handleRedirectSearch = () => {
    navigate('/search', { state: { isReload: true } });
  };

  return (
    <div className="NoResults_Container">
      <div className="Message_Container">
        {!isWatched ? (
          <>
            <img alt="No Results Found Icon" src="/oo/assets/icon/no-search-icon.svg" />
            <p>{SEARCHRESULTS_ERRORTEXT}</p>
          </>
        ) : (
          <>
            <img alt="No Results Found Icon" src="/oo/assets/icon/no-search-icon.svg" />
            <p>{WATCHEDRESULTS_ERRORTEXT}</p>
          </>
        )}
      </div>
      {isWatched && isMatchedLoadsHome && (
        <div className="Redirect_Search" onClick={handleRedirectSearch}>
          <img alt="Redirect to Search Icon" src="/oo/assets/icon/SearchError.svg" />
          <span>Search For Loads</span>
        </div>
      )}
    </div>
  );
};

export default NoResults;
